if (!customElements.get('lk-infinite-scroll')) {
  customElements.define('lk-infinite-scroll', class extends HTMLElement {
    connectedCallback() {
      this.grid = document.getElementById('product-grid');
      this.nextLink = this.querySelector('[data-next-page]');
      this.status = this.querySelector('[role="status"]');
      this.retry = this.querySelector('button');
      if (!this.grid || !this.nextLink || !('IntersectionObserver' in window)) return;
      this.classList.add('lk-scroll-enhanced');
      this.retry.hidden = false;
      this.onRetry = () => this.loadNext();
      this.retry.addEventListener('click', this.onRetry);
      this.observer = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) this.loadNext();
      }, { rootMargin: '350px 0px' });
      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.controller?.abort();
      this.retry?.removeEventListener('click', this.onRetry);
    }

    async loadNext() {
      if (this.busy || !this.nextLink || !this.isConnected) return;
      if (this.closest('.collection')?.classList.contains('loading')) return;
      const context = window.location.pathname + window.location.search;
      const nextURL = new URL(this.nextLink.href, window.location.origin);
      if (nextURL.origin !== window.location.origin) return;
      nextURL.searchParams.set('section_id', this.dataset.sectionId);
      this.busy = true;
      this.classList.remove('lk-scroll-error');
      this.retry.disabled = true;
      this.status.textContent = this.dataset.loading;
      this.controller = new AbortController();
      try {
        const response = await fetch(nextURL, { signal: this.controller.signal });
        if (!response.ok) throw new Error('Collection request failed');
        const page = new DOMParser().parseFromString(await response.text(), 'text/html');
        const incoming = page.querySelector('#product-grid');
        if (!incoming) throw new Error('Missing collection grid');
        if (!this.isConnected || context !== window.location.pathname + window.location.search) return;
        const existing = new Set([...this.grid.children].map(card => card.dataset.productId));
        const added = [];
        for (const card of [...incoming.children]) {
          if (card.dataset.productId && existing.has(card.dataset.productId)) continue;
          card.classList.add('scroll-trigger--cancel');
          card.querySelectorAll('.scroll-trigger').forEach(item => item.classList.add('scroll-trigger--cancel'));
          this.grid.append(card);
          existing.add(card.dataset.productId);
          added.push(card);
        }
        const next = page.querySelector('lk-infinite-scroll [data-next-page]');
        this.status.textContent = `${this.grid.children.length} ${this.dataset.shown}`;
        this.dispatchEvent(new CustomEvent('lk:products-appended', { bubbles: true, detail: { cards: added } }));
        if (next) {
          this.nextLink.href = next.href;
          this.retry.disabled = false;
          this.observer.observe(this);
        } else {
          this.observer.disconnect();
          this.nextLink.remove();
          this.nextLink = null;
          this.retry.hidden = true;
          this.status.textContent = this.dataset.complete;
        }
      } catch (error) {
        if (error.name === 'AbortError') return;
        this.observer?.disconnect();
        this.classList.add('lk-scroll-error');
        this.status.textContent = this.dataset.error;
        this.retry.textContent = this.dataset.retry;
        this.retry.disabled = false;
      } finally {
        this.busy = false;
      }
    }
  });
}
